import {CommonService} from './../../../shared/utils/common.service';
import {UtilsService} from './../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  private diccionarioModulo: any;
  private url: string;
  private urlMaestros: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
    this.urlMaestros = this._util.getDatosMaestros();
  }

  obtenerPorId(codMaterial: string): Observable<any> {
    console.log(this.urlMaestros);
    console.log(this.diccionarioModulo.url.cliente.obtenerPorId);
    return this._commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioModulo.url.cliente.obtenerPorId + codMaterial
    );
  }
}
